import { StyleSheet } from 'react-native';
import {
  bold,
  editLinkColor,
  fontSizeLarge,
  grey,
  fontSizeMedium,
  fontSizeSmall,
  white,
} from '../../../constants/palette';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  editLinkContainer: {
    justifyContent: 'flex-start',
  },
  editLinkText: {
    color: editLinkColor,
    fontWeight: bold,
    fontSize: fontSizeMedium,
  },
  genreButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  genreText: {
    fontSize: fontSizeMedium,
  },
  genreSubText: {
    fontSize: fontSizeSmall,
    color: grey,
    width: 250,
  },
  myGenresContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
    justifyContent: 'space-between',
  },
  scrollViewContainer: { flex: 1 },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  text: {
    color: white,
  },
  title: {
    fontSize: fontSizeLarge,
    fontWeight: bold,
    margin: 10,
  },
});

export default styles;
